import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Shield, Wrench, Search, Cpu, Percent, Award } from 'lucide-react';

const reasons = [
  {
    title: '12 Years Warranty',
    description: 'Your peace of mind is our priority. We proudly stand behind our work with a 12-year warranty.',
    icon: Shield,
  },
  {
    title: 'Repainting, Recoating & Repairs',
    description: 'Your trusted partner for comprehensive roof services from meticulous repainting to expert recoating.',
    icon: Wrench,
  },
  {
    title: 'Free Coating Inspection',
    description: 'We offer a complimentary coating inspection. Our experts assess your roof condition and provide valuable insights.',
    icon: Search,
  },
  {
    title: 'Advanced Painting Technology',
    description: 'We stay at the forefront of innovation with advanced painting technology for a flawless finish.',
    icon: Cpu,
  },
  {
    title: 'Save 35% on Roof Painting',
    description: 'Elevate your property without breaking the bank. Experience premium quality without compromising your budget.',
    icon: Percent,
  },
  {
    title: '100% Satisfaction Guaranteed',
    description: 'Your satisfaction is non-negotiable. We are committed to delivering results that exceed your expectations.',
    icon: Award,
  },
];

const WhyUs = () => {
  const { theme } = useTheme();

  return (
    <section 
      id="why-us" 
      className={`${theme.layout.sectionSpacing} ${theme.colors.backgroundAlt}`}
      data-testid="whyus-section"
    >
      <div className={theme.layout.container}>
        {/* Header */}
        <div className="text-center mb-16">
          <span className={`${theme.typography.bodyFont} text-[#ff5218] uppercase tracking-widest text-sm font-semibold`}>
            Our Advantages
          </span>
          <h2 className={`
            ${theme.typography.headingFont} ${theme.typography.headingWeight}
            ${theme.colors.textPrimary} text-3xl md:text-4xl lg:text-5xl mt-4
            ${theme.typography.headingTracking} uppercase
          `}>
            Why Choose Us
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div 
                key={reason.title}
                className={`group text-center ${theme.components.card}`}
                data-testid={`reason-${index}`}
              >
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center icon-box bg-[#ff5218] text-white">
                  <Icon className="w-8 h-8" />
                </div>

                <h3 className={`
                  ${theme.typography.headingFont} ${theme.colors.textPrimary}
                  text-lg md:text-xl font-semibold mb-3 uppercase text-sm
                `}>
                  {reason.title}
                </h3>
                <p className={`${theme.typography.bodyFont} ${theme.colors.textSecondary} text-sm leading-relaxed`}>
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
